<ng-container *ngIf="heatingCurve$ | async | ready as feature">
  <ng-container
    *ngTemplateOutlet="
      curve;
      context: { operatingProgram: operatingProgram$ | async | ready, heatingCurve: feature }
    "
  ></ng-container>
</ng-container>

<div class="select-wrapper">
  <vi-item
    data-at-shift
    *ngIf="heatingCurve$ | async | ready as feature"
    [title]="'+INSTALLATIONS.INSTALLATION.CIRCUIT.HEATING_CURVE.SHIFT' | translate"
    [valueSpecification]="feature | constraints: 'setCurve':'shift'"
    [asDropdown]="feature | executable: 'setCurve'"
    [value]="shiftValue$ | async"
    (valueChange)="onShiftChange($event, (feature?.properties)['shift']?.value)"
  ></vi-item>
  <vi-item
    data-at-slope
    *ngIf="heatingCurve$ | async | ready as feature"
    [title]="'+INSTALLATIONS.INSTALLATION.CIRCUIT.HEATING_CURVE.SLOPE' | translate"
    [valueSpecification]="feature | constraints: 'setCurve':'slope'"
    [asDropdown]="feature | executable: 'setCurve'"
    [value]="slopeValue$ | async"
    [mantissaPlaces]="1"
    (valueChange)="onSlopeChange($event, (feature?.properties)['slope']?.value)"
  ></vi-item>
  <app-flow-limit-temperature-panel [circuitId]="circuitId"></app-flow-limit-temperature-panel>
  <strong *ngIf="isHeatingCircuitWithActiveSRCAndDevices$ | async" class="setting-aware">{{
    '+INSTALLATIONS.INSTALLATION.CIRCUIT.SETTING_AWARE' | translate
  }}</strong>
</div>

<ng-template #curve let-operatingProgram="operatingProgram" let-feature="heatingCurve">
  <ng-container *ngIf="operatingProgramNormalTemperature$ | async as targetTemperature">
    <app-heating-curve
      data-at-heating-curve
      *ngIf="feature && feature.properties?.slope && feature.properties?.shift"
      [shift]="feature.properties?.shift?.value"
      [slope]="feature.properties?.slope?.value"
      [isE3HeatPumpDevice]="isE3HeatPumpDevice$ | async"
      [roomTemperature]="targetTemperature"
      [isHeatPumpFirstCH]="(compressorStatus$ | async | ready) && circuitId === '0'"
      [minFlowLimitTemperature]="flowLimitTemperature | featureValue: 'min':0"
      [maxFlowLimitTemperature]="flowLimitTemperature | featureValue: 'max':100"
      [isFlowTemperatureAvailable]="!!flowLimitTemperature"
    ></app-heating-curve>
  </ng-container>
</ng-template>

<div class="select-wrapper mt-[16px]">
  <!-- heating.circuits.n.sensors.temperature.supply -->
  <ng-container *ngIf="flowTemperature$ | async | ready as feature">
    <vi-item
      data-at-flow
      [error]="feature | error"
      [title]="'+INSTALLATIONS.INSTALLATION.CIRCUIT.HEATING_CURVE.FLOW' | translate"
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
    ></vi-item>
  </ng-container>

  <!-- heating.circuits.n.temperature -->
  <vi-item
    *ngIf="targetFlowTemperature$ | async | ready as feature"
    data-at-overlay-target-flow-temperature
    title="{{ '+INSTALLATIONS.INSTALLATION.CIRCUIT.TARGET_TEMPERATURE_LABEL' | translate }}"
    [value]="
      (isTargetFlowTemperatureVisible$ | async)
        ? (feature | value2: featurePropertyKey.value) + ' ' + (feature | unit: 'value')
        : NO_VALUE
    "
    [error]="feature | error"
  ></vi-item>

  <!-- heating.calculated.temperature.outside -->
  <vi-item
    *ngIf="calculatedOutsideTemperature$ | async | ready as feature"
    data-at-overlay-calculated-outside-temperature
    title="{{ '+INSTALLATIONS.INSTALLATION.CALCULATED_OUTSIDE_TEMPERATURE' | translate }}"
    value="{{ feature | value2: featurePropertyKey.value }} {{
      feature | unit: featurePropertyKey.value
    }}"
    [error]="feature | error"
    [tooltip]="true"
    [tooltipText]="'+INSTALLATIONS.INSTALLATION.CALCULATED_OUTSIDE_TEMPERATURE_INFO' | translate"
    [separateTooltipIcon]="true"
  ></vi-item>

  <!-- heating.sensors.temperature.outside -->
  <vi-item
    *ngIf="outsideTemperature$ | async | ready as feature"
    data-at-overlay-calculated-outside-temperature
    title="{{ '+INSTALLATIONS.INSTALLATION.BOILER.OUTSIDE_TEMPERATURE' | translate }}"
    value="{{ feature | value2: featurePropertyKey.value }} {{
      feature | unit: featurePropertyKey.value
    }}"
    [error]="feature | error"
  ></vi-item>
</div>
